/**
 * Card Product Swatch Interaction
 * Uses event delegation to handle swatch clicks for both static and dynamically loaded content
 */
(function () {
    'use strict';

    // Prevent multiple initializations
    if (window.cardSwatchDelegationInitialized) return;
    window.cardSwatchDelegationInitialized = true;

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.card-product__swatch-btn');
        if (!btn) return;

        // Prevent default and stop propagation to avoid triggering card link
        e.preventDefault();
        e.stopPropagation();

        var cardWrapper = btn.closest('.card-wrapper');
        if (!cardWrapper) return;

        var mediaContainer = cardWrapper.querySelector('.card__media .media');
        if (!mediaContainer) return;

        var primaryImg = mediaContainer.querySelector('img');
        if (!primaryImg) return;

        var src = btn.dataset.variantImage;
        var srcset = btn.dataset.variantImageSrcset;

        if (src && primaryImg) {
            primaryImg.src = src;
            if (srcset) primaryImg.srcset = srcset;
            if (btn.dataset.variantImageAlt) primaryImg.alt = btn.dataset.variantImageAlt;
            if (btn.dataset.variantImageWidth) primaryImg.width = btn.dataset.variantImageWidth;
            if (btn.dataset.variantImageHeight) primaryImg.height = btn.dataset.variantImageHeight;
        }

        // Update all product links to include variant query parameter
        var links = cardWrapper.querySelectorAll('a[href*="/products/"]');
        links.forEach(function (link) {
            try {
                var base = link.getAttribute('href').split('?')[0];
                link.setAttribute('href', base + '?variant=' + btn.dataset.variantId);
            } catch (err) { }
        });

        // Update active state
        var swatchButtons = cardWrapper.querySelectorAll('.card-product__swatch-btn');
        swatchButtons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
    });
})();
